import adminRequest from '@formosa/shared/api/adminRequest';
import { travelAdminJson } from '@formosa/shared/api/parseTravelAdminJson';
import { ADMIN_API } from '@formosa/shared/constants/endpoints';

/**
 * 自訂地點治理後台 API（檢舉驅動；LEGACY approve／reject 保留但不作為主 UI）。
 */
export const customLocationAdminApi = {
  governanceQueue: (params) =>
    adminRequest.get(`${ADMIN_API}/travel-manage/custom-locations/governance-queue`, {
      params,
      ...travelAdminJson,
    }),

  keepPublished: (id, data) =>
    adminRequest.post(
      `${ADMIN_API}/travel-manage/custom-locations/${String(id)}/keep-published`,
      data,
      travelAdminJson,
    ),

  remove: (id, data) =>
    adminRequest.post(
      `${ADMIN_API}/travel-manage/custom-locations/${String(id)}/remove`,
      data,
      travelAdminJson,
    ),

  /** LEGACY PENDING_PUBLIC */
  reviewQueue: (params) =>
    adminRequest.get(`${ADMIN_API}/travel-manage/custom-locations/review-queue`, {
      params,
      ...travelAdminJson,
    }),

  approve: (id, data) =>
    adminRequest.post(
      `${ADMIN_API}/travel-manage/custom-locations/${String(id)}/approve`,
      data,
      travelAdminJson,
    ),

  reject: (id, data) =>
    adminRequest.post(
      `${ADMIN_API}/travel-manage/custom-locations/${String(id)}/reject`,
      data,
      travelAdminJson,
    ),
};
